import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/viadeo-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-352c0-26.5 21.5-48 48-48h352zM280.7 381.2c35.4-38.3 38.1-89 22.8-125.6-7.9 4.9-16.9 8.6-26.4 10.5 4.8 11.4 6.9 23.5 6.9 35.7 0 48.6-36.2 88.2-86.2 87.2l2.4-0.2c46.4-29.2 68.3-74.1 68.3-128.2 0-23.8-4.1-47.5-11.8-70v-0.4c-2.3-31.6-17.1-75.8-44.2-94.1 17.6 29.9 33 61.6 44.2 94.5 0.6 7.3 0.6 14.8 0.6 22.1 0 57.4-11.4 151-72.9 175-41-7.2-69.5-42.9-69.5-85.9 0-47.2 35.8-88.9 84.6-88.9 10.5 0 21 1.9 30.7 6 1.1-9.5 4.1-18.7 8.4-27.1-12.5-4.6-25.8-6.7-39.1-6.7-101 0-149.2 122.5-81.2 196.1 42.4 46.6 120 46.2 162.4 0zM309 233.7c49.4 0 68.8-84.1 36.3-130.3-19.4 41.5-50.8 29.5-72.4 50-7.7 7.5-12.9 21.3-12.9 31.6 0 8.8 2.8 17 7.5 24.3 29.7-6.9 61.4-28.8 73.9-56.7-0.4 3.4-3 9-4.5 12-12.7 22.3-40.4 41-62.3 53 9.3 9 21.1 16.1 34.4 16.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/viadeo-square.js
// module id = 1074
// module chunks = 0